import { SearchCriteria } from "./search-criteria";

export class ClientPointsBalanceSearchCriteria extends SearchCriteria {
        public ClientId: number;
        public AccountSetupId: number;
        public Id: number;
}

